import './array_helpers'
import './string_helpers'
import './dom_helpers'
import './object_helpers'
import './number_helpers'
import './date_helpers'
import './date_range_helpers'
import './file_helpers'

window.generateGuid = function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}
